module.exports = __webpack_public_path__ + "static/media/jenny.a1c6bae8.png";